import { jsx as _jsx } from "react/jsx-runtime";
import { borderFicheDetailsDefault, borderTitleDetailsDefault, } from "@/utils/funcs";
import { useThemeConfig } from "../themeConfigContext";
import { GridSection } from "./gridSection";
export default function DetailViewLayoutSection(_a) {
    var t = useThemeConfig().t;
    return (_jsx(GridSection, { rows: [
            [
                {
                    title: "Detail view title",
                    label: t("LBL_BORDER_RADIUS_HEADER_TOP", { ns: "Administration" }) ||
                        "Arrondi des coins supérieurs de l'en-tête",
                    opacity: false,
                    borderRadius: true,
                    extraProps: { borderDefaultValue: borderTitleDetailsDefault },
                },
            ],
            [
                {
                    title: "Detail view fiche",
                    label: t("LBL_DETAIL_VIEW_MARGIN", { ns: "Administration" }) ||
                        "Espacement externe du composant",
                    opacity: false,
                    margin: true,
                    extraProps: { borderDefaultValue: borderFicheDetailsDefault },
                },
            ],
            [
                {
                    title: "Detail view fiche",
                    label: t("LBL_BORDER_RADIUS_DETAIL_CONTENT", { ns: "Administration" }) ||
                        "Arrondi des coins du contenu",
                    opacity: false,
                    borderRadius: true,
                },
            ],
            [
                {
                    title: "Detail view fields",
                    label: t("app.LBL_FIELDS", { ns: "common" }) || "Champs",
                    margin: true,
                    padding: true,
                    opacity: false,
                    extraProps: {
                        labelColor: true,
                        backgroundColor: true,
                        borderColor: true,
                    },
                },
            ],
        ] }));
}
